module.exports = __webpack_public_path__ + "img/municipio-mais-simples.edd55067.png";